import type { StateIconProps } from '@spotify/confidence-core-react';
import {
  ObservationsV1IssueState as IssueState,
  ObservationsV1IssueCloseReason,
} from '@spotify/confidence-graphql';

const ISSUE_STATE_LABELS: Partial<Record<IssueState, string>> = {
  [IssueState.Waiting]: 'Waiting',
  [IssueState.Working]: 'Working',
  [IssueState.Closed]: 'Closed',
};

const ISSUE_STATE_ICON_STATES: Partial<
  Record<IssueState, StateIconProps['state']>
> = {
  [IssueState.Waiting]: 'draft',
  [IssueState.Working]: 'live',
  [IssueState.Closed]: 'ended',
};

export const getIssueStateLabel = (state: IssueState): string =>
  ISSUE_STATE_LABELS[state] ?? 'Unknown';

export const ISSUE_CLOSE_REASONS: ObservationsV1IssueCloseReason[] = [
  ObservationsV1IssueCloseReason.Fixed,
  ObservationsV1IssueCloseReason.WontFix,
  ObservationsV1IssueCloseReason.NonIssue,
];

export const getIssueCloseReasonId = (
  closeReason: ObservationsV1IssueCloseReason,
): string => `close-${closeReason.toLowerCase().replace(/_/g, '-')}`;

export const getIssueCloseReasonLabel = (
  closeReason: ObservationsV1IssueCloseReason | null | undefined,
): string => {
  switch (closeReason) {
    case ObservationsV1IssueCloseReason.Fixed:
      return 'Fixed';
    case ObservationsV1IssueCloseReason.WontFix:
      return "Won't fix";
    case ObservationsV1IssueCloseReason.NonIssue:
      return 'Not an issue';
    case ObservationsV1IssueCloseReason.Inactive:
      return 'Inactive';
    default:
      return 'Closed';
  }
};

export const getIssueStateIconState = (
  state: IssueState,
): StateIconProps['state'] => ISSUE_STATE_ICON_STATES[state] ?? 'draft';
